import { type FC, useMemo } from "react";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import { InspirationColdIntro } from "web_myplann/Inspiration/Components/InspirationColdIntro";
import { InspirationExampleText } from "web_myplann/Inspiration/Components/InspirationExampleText";
import { InspirationStatCardList } from "web_myplann/Inspiration/Components/InspirationStatCardList";
import { getEarlyFreedomExample } from "web_myplann/Inspiration/EarlyFreedom/Utils/getEarlyFreedomExample";
import { useInspirationMoney } from "web_myplann/Inspiration/Hooks/useInspirationMoney";

const R = Resources.Inspiration.EarlyFreedom;

export const EarlyFreedomColdIntro: FC = () => {
	const example = useMemo(getEarlyFreedomExample, []);
	const money = useInspirationMoney();

	return (
		<InspirationColdIntro
			intro={R.intro}
			exampleTitle={R.exampleTitle}
			exampleHint={R.exampleHint}
		>
			<InspirationExampleText
				text={R.exampleBody}
				values={{
					spend: money(example.spend),
					rent: money(example.rent),
					gap: money(example.gap),
					capital: money(example.capital),
				}}
			/>

			<InspirationStatCardList
				stats={[
					{
						label: R.exampleTodayLabel,
						amount: money(example.rent),
						tone: "neutral",
					},
					{
						label: R.exampleNeedLabel,
						amount: `~${money(example.capital)}`,
						tone: "highlight",
					},
				]}
			/>
		</InspirationColdIntro>
	);
};
